
<template>
  <div id="app" v-wechat-title='$route.meta.title'>
    <!-- <keep-alive>
        <router-view  v-if="$route.meta.keepAlive" />
    </keep-alive> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
  #app{
    height: 100%;
    overflow-y: auto;
  }
  div::-webkit-scrollbar{
        width: 5px;
      }
  div::-webkit-scrollbar-track{
    background-color: #fafafa;
  }
  div::-webkit-scrollbar-thumb {
     background:$color-primary; 
  }
</style>
